export default {"src":"/_next/static/media/hamburger.5ed49145.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};